































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { refResepStore } from "@/store/modules/ReferensiResep";
import ObatSearchBox from "@/components/resep/ObatSearchBox.vue";
import ResepRalanUnifiedSvc from "@/services/ResepRalanUnified";

function parseFrekuensiPerHari(s: string): number | null {
  const lower = s.toLowerCase().trim();
  const xMatch = lower.match(/^(\d+)\s*x\s*sehari/);
  if (xMatch) return parseInt(xMatch[1], 10);
  const jamMatch = lower.match(/tiap\s+(\d+)\s*jam/);
  if (jamMatch) return Math.floor(24 / parseInt(jamMatch[1], 10));
  if (lower.startsWith("k/p")) return 0; // PRN — no auto-calc
  return null;
}

function parseDoseMultiplier(s: string): number {
  const m = s.match(/^(\d+(?:[.,]\d+)?)/);
  if (!m) return 1;
  const n = parseFloat(m[1].replace(",", "."));
  return n > 0 && n < 20 ? n : 1;
}

const RUTE_QUICK_PICKS = ["oral", "iv", "im", "sc", "topikal", "supp"];
const FREK_QUICK_PICKS = [
  "1 x sehari",
  "2 x sehari",
  "3 x sehari",
  "tiap 8 jam",
  "tiap 12 jam",
  "k/p"
];
const DURASI_PICKS = [
  { value: 3, label: "3 hr" },
  { value: 5, label: "5 hr" },
  { value: 7, label: "7 hr" },
  { value: 14, label: "14 hr" },
  { value: 30, label: "30 hr" }
];

@Component({ components: { ObatSearchBox } })
export default class ObatItemFastRow extends Vue {
  @Prop() item: any;
  @Prop() index: number;
  @Prop({ default: "" }) depoId: string;

  showObatSearch = false;
  ruteMenu = false;
  frekMenu = false;
  durasiHari: number | null = null;
  durasiCustom: number | null = null;
  defaultsSource: string | null = null;
  validationMsg = "";

  get refRute() {
    return refResepStore.refRute || [];
  }

  get refFrekuensi() {
    return refResepStore.refFrekuensi || [];
  }

  get rutePicks() {
    return this.refRute
      .filter((r: any) =>
        RUTE_QUICK_PICKS.includes(String(r.nama).toLowerCase().trim())
      )
      .map((r: any) => ({
        id: r.id,
        label: String(r.nama).toUpperCase()
      }));
  }

  get frekPicks() {
    return this.refFrekuensi
      .filter((f: any) =>
        FREK_QUICK_PICKS.includes(String(f.nama).toLowerCase().trim())
      )
      .map((f: any) => ({ id: f.id, label: f.nama }));
  }

  get durasiPicks() {
    return DURASI_PICKS;
  }

  get ruteOtherLabel() {
    if (!this.item.rute_id) return "lainnya";
    const r = this.refRute.find((x: any) => x.id === this.item.rute_id);
    return r && !this.rutePicks.find(p => p.id === r.id) ? r.nama : "lainnya";
  }

  get frekOtherLabel() {
    if (!this.item.frekuensi_id) return "lainnya";
    const f = this.refFrekuensi.find(
      (x: any) => x.id === this.item.frekuensi_id
    );
    return f && !this.frekPicks.find(p => p.id === f.id) ? f.nama : "lainnya";
  }

  get qtyAuto() {
    return !!(this.item.qty && this.item._auto_qty);
  }

  get rowClass() {
    if (!this.item.obat_id) return "row-empty";
    if (this.validationMsg) return "row-invalid";
    return "row-ok";
  }

  get defaultsSourceLabel() {
    if (this.defaultsSource === "personal") return "default Anda";
    if (this.defaultsSource === "institusi") return "default RS";
    if (this.defaultsSource === "template") return "template";
    return "";
  }

  get defaultsTooltip() {
    if (this.defaultsSource === "personal")
      return "Smart default berdasar resep terakhir Anda untuk obat ini";
    if (this.defaultsSource === "institusi")
      return "Smart default berdasar pola peresepan RS untuk obat ini";
    if (this.defaultsSource === "template")
      return "Smart default berdasar template resep";
    return "";
  }

  mounted() {
    if (this.item && this.item.obat_id && !this.item._defaults_loaded) {
      this.loadDefaults();
    }
  }

  @Watch("item.obat_id")
  onObatChanged(val: string, old: string) {
    if (val && val !== old) {
      this.item._defaults_loaded = false;
      this.loadDefaults();
    }
  }

  async loadDefaults() {
    if (!this.item.obat_id) return;
    try {
      const d = await ResepRalanUnifiedSvc.obatDefaults(this.item.obat_id);
      this.defaultsSource = d.source;
      if (d.source === "none") return;

      // Only fill empty fields — never overwrite doctor input.
      if (!this.item.rute_id && d.rute_id) this.item.rute_id = d.rute_id;
      if (!this.item.frekuensi_id && d.frekuensi_id)
        this.item.frekuensi_id = d.frekuensi_id;
      if (!this.item.ap_dosis && d.ap_dosis) this.item.ap_dosis = d.ap_dosis;
      if (!this.item.ap_tambahan && d.ap_tambahan)
        this.item.ap_tambahan = d.ap_tambahan;
      if (!this.item.qty && d.qty) {
        this.item.qty = d.qty;
        this.item._auto_qty = true;
      }
      this.item._defaults_loaded = true;
      this.recalcQty();
    } catch (e) {
      this.defaultsSource = "none";
    }
  }

  setRute(id: number) {
    this.item.rute_id = id;
  }

  setFrek(id: number) {
    this.item.frekuensi_id = id;
    this.recalcQty();
  }

  setDurasi(value: number) {
    this.durasiHari = value;
    this.durasiCustom = null;
    this.item._durasi_hari = value;
    this.recalcQty();
  }

  onCustomDurasi() {
    if (this.durasiCustom && this.durasiCustom > 0) {
      this.durasiHari = this.durasiCustom;
      this.item._durasi_hari = this.durasiCustom;
      this.recalcQty();
    }
  }

  recalcQty() {
    if (!this.item._durasi_hari) return;
    const frek = this.refFrekuensi.find(
      (f: any) => f.id === this.item.frekuensi_id
    );
    if (!frek) return;
    const perHari = parseFrekuensiPerHari(String(frek.nama));
    if (!perHari) return;
    const dose = parseDoseMultiplier(String(this.item.ap_dosis || "1"));
    const calc = Math.ceil(perHari * dose * this.item._durasi_hari);
    if (calc > 0) {
      this.item.qty = calc;
      this.item._auto_qty = true;
    }
  }

  removeItem(idx: number) {
    this.$emit("remove-item", idx);
  }

  handleSelectObat(val: any) {
    this.item.obat_nama = val.nama;
    this.item.obat_id = val.id;
    this.item.harga = val.harga;
    this.item.qty_unit = val.satuan;
    this.showObatSearch = false;
    this.item._defaults_loaded = false;
    this.loadDefaults();
  }
}
